import { jwtDecrypt } from "../shared/JwtHelper";
import axios from "axios";
import authHeader from "./AuthHeader";

const API_URL = process.env.VUE_APP_MS_CORE;

class LoginService {
  getUserFromToken(token) {
    const jwtDecodedValue = jwtDecrypt(token);
    return jwtDecodedValue.userDetails;
  }

  getClientFromToken(token) {
    const jwtDecodedValue = jwtDecrypt(token);
    return jwtDecodedValue.client;
  }

  resetLink(payload) {
    return axios.post(`${API_URL}/reset`, payload, { headers: authHeader() });
  }

  initAccountCustomer(payload) {
    return axios.post(`${API_URL}/confirm`, payload, { headers: authHeader() });
  }

  resetPassword(payload) {
    return axios.post(`${API_URL}/resetPassword`, payload, {
      headers: authHeader(),
    });
  }

  isMaintenance() {
    return axios.get(`${API_URL}/config/offline`, {
      headers: authHeader(),
    });
  }
}

export default new LoginService();
